// Fetch wrapper: bearer token from Clerk, a timeout on every call, readable errors.
type TokenGetter = () => Promise<string | null>;
let getToken: TokenGetter = async () => null;
export function registerTokenGetter(fn: TokenGetter): void { getToken = fn; }

export class ApiError extends Error {
  constructor(public status: number, message: string) { super(message); }
}

export async function api<T>(path: string, init: RequestInit = {}, timeoutMs = 25_000): Promise<T> {
  const token = await getToken();
  let res: Response;
  try {
    res = await fetch(path, {
      ...init,
      headers: { ...(init.headers as Record<string, string> | undefined), ...(token ? { authorization: `Bearer ${token}` } : {}) },
      signal: AbortSignal.timeout(timeoutMs),
    });
  } catch (err) {
    const e = err as Error;
    throw new ApiError(0, e.name === 'TimeoutError' ? `No answer after ${Math.round(timeoutMs / 1000)} s` : e.message);
  }
  const body = (await res.json().catch(() => null)) as { error?: string; detail?: string } | null;
  if (!res.ok) throw new ApiError(res.status, body?.error ?? `${res.status} ${res.statusText}`);
  return body as T;
}
